import React from 'react';
import clsx from 'clsx';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowDown } from '@fortawesome/pro-light-svg-icons/faArrowDown';
import { faArrowUp } from '@fortawesome/pro-light-svg-icons/faArrowUp';
import { TypedMemo } from '../../../common/types';
import { TrackSortKey } from '../sortTracks';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the whole screen; each part uses its own slice of it */
import styles from '../Streaming.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface SortHeaderProps {
  column: TrackSortKey;
  label: string;
  sort: { key: TrackSortKey; descending: boolean };
  onSort: (key: TrackSortKey) => void;
  isNumber?: boolean;
}

/** A column head that sorts the table (design d1: sort by a column head). */
const SortHeaderComponent: React.FC<SortHeaderProps> = ({ column, label, sort, onSort, isNumber = true }) => {
  const isOn = sort.key === column;
  const order = sort.descending ? 'descending' : 'ascending';
  return (
    <th className={clsx(isNumber && styles.numCell)} aria-sort={isOn ? order : undefined}>
      <button type="button" className={clsx(styles.sortButton, isOn && styles.sortOn)} onClick={() => onSort(column)}>
        {label}
        {isOn ? <FontAwesomeIcon icon={sort.descending ? faArrowDown : faArrowUp} /> : null}
      </button>
    </th>
  );
};

export const SortHeader = TypedMemo(SortHeaderComponent);
